import { getAxiosClientWithToken } from 'api';
import { ListChargerHistoryRequest } from 'redux/slice/listChargerHistory';

export const getListChargerHistory = (params: ListChargerHistoryRequest) => {
    return getAxiosClientWithToken().get('admin/charging-history', { params });
};
